<template>
  <div class="index">
    <router-view />
    <van-tabbar :route="istrue">
      <van-tabbar-item
        class="iconfont iconshouyejianying"
        replace
        to="tabbar1"
        @click="tz1('/index/tabbar1')"
        :class="{ active: index == '/index/tabbar1' }"
        name="tabbar1"
      >首页</van-tabbar-item>
      <van-tabbar-item
        class="iconfont iconicon04"
        replace
        to="tabbar2"
        @click="tz1('/index/tabbar2')"
        :class="{ active: index == '/index/tabbar2' }"
        name="tabbar2"
      >分类</van-tabbar-item>
      <van-tabbar-item class="iconfont iconremen" replace>
        <a
          class="a"
          href="https://m.jingxi.com/mcoss/wxmall/home?_fd=jx&ptag=17008.1.14&vk=17576652604981107&ptype=2"
        >惊喜</a>
      </van-tabbar-item>
      <van-tabbar-item
        class="iconfont icongouwuchekong"
        replace
        to="tabbar4"
        @click="tz1('/index/tabbar4')"
        :class="{ active: index == '/index/tabbar4' }"
        name="tabbar4"
      >购物车</van-tabbar-item>
      <van-tabbar-item class="iconfont iconwode-copy" replace>
        <a
          class="a"
          href="https://plogin.m.jd.com/login/login?appid=300&returnurl=https%3A%2F%2Fwq.jd.com%2Fpassport%2FLoginRedirect%3Fstate%3D1101456532223%26returnurl%3Dhttps%253A%252F%252Fhome.m.jd.com%252FmyJd%252Fnewhome.action%253Fsceneval%253D2%2526ufc%253D81c311839dbb719d39d1b3e3c94ac71b%2526&source=wq_passport"
        >我的</a>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
// const show1 = () => import("@/components/show/show1.vue");
export default {
  components: {
    // 组件注册
    // show1
  },
  data() {
    return {
      index: this.$router.currentRoute.path,
      // active: 0,
      istrue: true,
      tza: null
    };
  },
  methods: {
    // a1() {
    //   this.tza = 3;
    //   this.$refs.act1.style.color = "#ff4b4b";
    // },
    // a2() {
    //   this.tza = 5;
    //   this.$refs.act2.style.color = "#ff4b4b";
    // },
    tz1(innn) {
      this.index = innn;
      this.$store.commit("change", innn);
      // console.log(this.$router.currentRoute.path);
    }
  },
  computed: {
    //   计算属性
  },
  watch: {
    // 监听属性
  },
  updated() {
    // Vue实例更新后执行
    this.index = this.$router.currentRoute.path;
  },
  mounted() {
    // Vue实例渲染完成后执行
    // console.log(this.xp);
  }
};
</script>
<style lang="scss">
.van-tabbar-item__text {
  font-size: 0.7rem !important;
}
.iconfont {
  &::before {
    font-size: 0.8rem !important;
  }
}
.active {
  color: rgb(255, 75, 75) !important;
}
.van-tabbar-item {
  font-weight: 500 !important;
  &::before {
    font-weight: 600 !important;
  }
}
.a {
  color: #999;
}
</style>
